var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoRed(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 300 100",
    style: {
      enableBackground: "new 0 0 300 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F15A4F;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.4,75h6.4l1.7-5.7c0.2-0.5,0.9-2.5,3.4-2.5h15.6c2.4,0,3.2,2,3.3,2.5l1.8,5.7h6.7L70.7,25H60.6L46.4,75z  M57.6,58l7.1-26.2c0.1-0.5,0.3-0.9,0.8-0.9c0.5,0,0.8,0.4,0.9,0.9L73.7,58c0.2,0.8,0.4,3.3-2.6,3.3H60.2 C57.2,61.4,57.4,58.8,57.6,58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M90.6,75h16c11.7,0,19.3-6.3,19.3-17.4c0-6.5-2.8-11.2-7.9-13.8c4.6-1.4,6.1-5.6,6.1-9.1 c0-5.9-4.1-9.8-11.1-9.8H90.6L90.6,75L90.6,75z M97,67.1V48.4c0-1.8,1.2-3.1,3-3.1h5.7c8.4,0,13.8,4.6,13.8,12.1 c0,7.6-5.4,12.2-13.8,12.2h-5.9C98.1,69.6,97,68.6,97,67.1z M97,37.5v-4.6c0-1.5,1.1-2.5,2.8-2.5h12.4c3.4,0,5.5,1.9,5.5,4.8 c0,2.8-2,4.8-5.5,4.8H99.8C98.1,40,97,39,97,37.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M174.8,75h6.3V47.3c0-0.8,0.2-1.9,1.6-1.9c1.2,0,1.7,1.1,2.1,1.6L203,75h7.3l-17.8-27.2 c-0.3-0.4-0.5-0.8-0.5-1.2c0-0.7,0.5-1.3,1.7-1.3h6.9c6.3,0,10.6-4.2,10.6-10.2S206.9,25,200.6,25h-25.9L174.8,75L174.8,75z  M181.1,37.1v-4.1c0-1.9,1.2-2.7,3.1-2.7h15.2c3.4,0,5.5,1.8,5.5,4.8c0,2.9-2.1,4.8-5.5,4.8h-15.2C182.3,40,181.1,39.2,181.1,37.1z "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M214.7,75h6.5l1.7-5.7c0.2-0.5,0.9-2.5,3.4-2.5h15.6c2.4,0,3.2,2,3.3,2.5l1.8,5.7h6.7L239,25h-10.1L214.7,75z  M225.9,58l7.1-26.2c0.1-0.5,0.3-0.9,0.9-0.9c0.5,0,0.8,0.4,0.9,0.9L242,58c0.2,0.8,0.4,3.3-2.6,3.3h-11 C225.5,61.4,225.7,58.8,225.9,58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M147.9,64.6c10.5,0,17.6-7,17.6-17.6V25.1h-6.4v22c0,7.2-4.5,11.9-11.2,11.9c-6.7,0-11.2-4.8-11.2-11.9v-22 h-6.4V47C130.3,57.6,137.4,64.6,147.9,64.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M165.4,75h-35.1v-6.2h35.1V75z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRed);
export default __webpack_public_path__ + "static/media/logo-red.955c78d808a647fc052fe68987d8f958.svg";
export { ForwardRef as ReactComponent };